module.exports = __webpack_public_path__ + "img/play--encircled.32927321.svg";